'use client';
import { Drawer } from '@mui/material';
import React from 'react';
import { styles } from './drawer.styles';
import { BoxComponent } from '../base/box/Box';

type SidebarProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  children: React.ReactNode;
  rightPlacement?: boolean;
};

const Sidebar = ({ open, setOpen, children, rightPlacement }: SidebarProps) => {
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Drawer
      open={open}
      onClose={handleDrawerClose}
      sx={styles.drawerContainer}
      anchor={rightPlacement ? 'right' : 'left'}
    >
      <BoxComponent sx={styles.mainContainer}>{children}</BoxComponent>
    </Drawer>
  );
};

export { Sidebar };
